import { Injectable } from '@angular/core';
import {AbstractDatabaseService} from "../../tandem-core/services/abstract-database.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {Goal} from "../models/goal";

@Injectable({
  providedIn: 'root'
})
export class GoalService extends AbstractDatabaseService<Goal> {

  constructor(protected override afs: AngularFirestore) {
    super('goals', afs);
  }

  async findByName(name: string, userId: string): Promise<any> {
    const querySnapshot = await this.afs.collection('goals', ref =>
      ref.where('name', '==', name).where('userId', '==', userId)
    ).get().toPromise();

    let foundItem = null;
    // @ts-ignore
    querySnapshot.forEach(doc => {
      if (doc.exists) {
        foundItem = { id: doc.id, ...doc.data() as Goal };
      }
    });

    return foundItem;
  }
}
